import axios from "axios";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import Top from "../components/Top";
import { MdEdit } from "react-icons/md";
import Navbar from "../components/Navbar";
import { ClipLoader } from "react-spinners";

const UserList = ({ currentUser }) => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loading2, setLoading2] = useState(false);
    const [showDeleteBox, setShowDeleteBox] = useState(false);
    const [email, setEmail] = useState("");

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await axios.get(
                    `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/api/v1/user/all`,
                    { withCredentials: true }
                );
                setLoading(false)
                setUsers(response.data.users);
            } catch (error) {
                setLoading(false)
                toast.error("Failed to fetch users.");
            }
        };
        fetchUsers();
    }, []);

    const handleDelete = async () => {
        try {
            setLoading2(true)
            let response = await axios.delete(
                `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
                }/api/v1/user/delete/${email}`,
                { withCredentials: true }
            );
            toast.success(response.data.message);
            setUsers(users.filter((user) => user.email !== email));
            setShowDeleteBox(false)
            setLoading2(false)
        } catch (error) {
            toast.error("Failed to delete user.");
            setShowDeleteBox(false)
            setLoading2(false)
        }
    };

    const handleDeleteBox = (email) => {
        setEmail(email)
        setShowDeleteBox((prev) => !prev)
    }

    return (
        <div className="py-6 px-3 sm:px-6 xl:px-8">
            <div
                className={`w-screen h-screen bg-[#0A0813E3] flex items-center justify-center fixed z-[99] top-0 left-0 transition-opacity duration-200 ${!showDeleteBox
                    ? "opacity-0 scale-95 pointer-events-none"
                    : "opacity-100 scale-100"
                    }`}
            >
                <div
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="delete-user-title"
                    className={`bg-white absolute rounded-[24px] shadow-md p-8 w-[311px] h-[353px] sm:h-[260px] sm:w-[360px] xl:h-[260px] xl:w-[403px] flex flex-col gap-4 items-center justify-center text-center sm:p-9 xl:p-10 sm:gap-4 xl:gap-4 transition-transform duration-400`}
                >
                    <img src="/images/error.png" className="w-[36px]" alt="" />
                    <h2 id="delete-user-title" className="font-bold text-[20px] leading-[122%] tracking-[0%] text-center sm:text-[18px] xl:text-[20px] 2xl:text-[22px] xxl:text-2xl sm:leading-none xl:leading-none text-[#5D0E23] sm:tracking-normal">
                        Are you sure you want to delete this user.
                    </h2>
                    <div className="flex gap-2">
                        <button
                            type="button"
                            onClick={handleDelete}
                            className="mt-4 bg-[#5D0E23] hover:bg-[#55051A] font-semibold sm:text-[11px] xl:text-[12px] 2xl:text-[13px] xxl:text-[14px] leading-none tracking-[-0.04em] text-center  cursor-pointer translate-all duration-400 text-white py-3 px-9 sm:py-3 xl:py-3 2xl:py-4 xxl:py-5 sm:px-9 xl:px-10 2xl:px-11 xxl:px-12 rounded-lg"
                        >
                            {loading2 ? <ClipLoader color="white" size={"1em"}/> : "Yes"}
                        </button>
                        <button
                            type="button"
                            onClick={handleDeleteBox}
                            className="mt-4 bg-[#5D0E23] hover:bg-[#55051A] font-semibold sm:text-[11px] xl:text-[12px] 2xl:text-[13px] xxl:text-[14px] leading-none tracking-[-0.04em] text-center  cursor-pointer translate-all duration-400 text-white py-3 px-9 sm:py-3 xl:py-3 2xl:py-4 xxl:py-5 sm:px-9 xl:px-10 2xl:px-11 xxl:px-12 rounded-lg"
                        >
                            No
                        </button>
                    </div>
                </div>
            </div>
            <Top currentUser={currentUser} />
            <Navbar currentUser={currentUser} />
            <div className="sm:block xl:block">
                <h2 className="pt-1 text-[18px] sm:text-[20px] xl:text-[22px] 2xl:text-xl   font-semibold text-[#5D0E23] leading-none tracking-normal">
                    Users List
                </h2>

                <div className="overflow-x-auto mt-[2px] sm:mt-1 xl:mt-2">
                    <table className="border-collapse overflow-hidden rounded-[6px] w-[450px] sm:w-full xl:w-full">
                        <thead className="bg-[#87213C] text-white font-semibold text-[12px] leading-none tracking-[0px] px-10">
                            <tr className="sm:text-[13px] xl:text-[14px] 2xl:text-[15px] xxl:text-[16px] font-semibold leading-none tracking-[0px] ">
                                <th className="whitespace-nowrap text-left px-4 py-1 rounded-tl-[6px] rounded-bl-[6px]">
                                    Name
                                </th>
                                <th className="whitespace-nowrap text-left px-4">
                                    Email
                                </th>
                                <th className="whitespace-nowrap text-left px-4">
                                    Role
                                </th>
                                <th className="text-left whitespace-nowrap px-4 rounded-tr-[6px] rounded-br-[6px]">
                                    Action
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {loading ? <tr>
                                <td colSpan="4" className="text-center py-10">
                                    <ClipLoader size={"2em"} />
                                </td>
                            </tr> :
                                users.map((user, index) => (
                                    <tr
                                        key={index}
                                        className="text-[#2E2E2E] text-[12px]  border-b border-[#EDEDED] bg-white hover:bg-[#F5F5F5] align-center font-medium sm:text-[13px] xl:text-[14px] 2xl:text-[15px] xxl:text-[16px] leading-none tracking-[0px] "
                                    >
                                        <td className="px-4 py-2 text-left">{user.name}</td>
                                        <td className="px-4 py-2 text-left">{user.email}</td>
                                        <td className="px-4 py-2 text-left">
                                            {user.role.charAt(0).toUpperCase() + user.role.slice(1)}
                                        </td>
                                        <td className="px-4 py-2 text-left">
                                            {user.email ===
                                                import.meta.env.VITE_REACT_APP_FIRST_ADMIN ? null : (
                                                <div className="flex justify-start items-center">
                                                    <button
                                                        aria-label={`Delete ${user.email}`}
                                                        onClick={() => handleDeleteBox(user.email)} className="transition duration-200 cursor-pointer pr-2"
                                                    >
                                                        <img
                                                            className="w-[10px] sm:w-[11px] xl:w-[12px] 2xl:w-[14px] xxl:w-[16px]"
                                                            src="/images/delete.png"
                                                            alt=""
                                                        />
                                                    </button>
                                                    <Link
                                                        aria-label={`Edit ${user.email}`}
                                                        to={`/edit-user/${user.id}/${user.name}/${user.email}/${user.role}`}
                                                        className="transition duration-200 cursor-pointer w-[10px] sm:w-[11px] xl:w-[12px] 2xl:w-[14px] xxl:w-[16px]"
                                                    >
                                                        <MdEdit />
                                                    </Link>
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default UserList;
